import React from "react";
import { NavLink } from "react-router-dom";
import { Wallet, ArrowLeftRight, Clock, Settings } from "lucide-react";

const items = [
  { to: "/portfolio", label: "Portfolio", icon: Wallet, testid: "nav-portfolio" },
  { to: "/send", label: "Transfer", icon: ArrowLeftRight, testid: "nav-send" },
  { to: "/activity", label: "Activity", icon: Clock, testid: "nav-activity" },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

export default function BottomNav() {
  return (
    <nav className="glass sticky bottom-0 z-20 flex items-center justify-around border-t border-[#1F2430] px-2 py-2">
      {items.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center gap-1 rounded-xl py-2 transition-colors ${
              isActive ? "text-neon" : "text-[#6B7280] hover:text-[#9CA3AF]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon className="h-5 w-5" strokeWidth={isActive ? 2.4 : 1.8} />
              <span className="font-sans text-[10px] font-medium tracking-wide">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
